import { createSlice } from '@reduxjs/toolkit'

// Slice
const initial = {
    list: [],
    active: [],
    levels: [],
}

const slice = createSlice({
    name: 'resources',
    initialState: {
        ...initial,
    },
    reducers: {
        addResources: (state, action) => {
            let { resources = [] } = action.payload;
            state.list = resources;
            state.active = resources.filter(item => item.status == 'ACTIVE')
        },
        clearResources: (state, action) => {
            state.list = [];
            state.active = [];
            state.levels = [];
        },
        addLevels: (state, action) => {
            let { levels = [] } = action.payload;
            state.levels = levels;
        },
        clearLevels: (state) => {
            state.levels = [];
        }
    },
});

export default slice.reducer

// Actions
const { addResources, clearResources, addLevels, clearLevels } = slice.actions

export const addResourcesAction = (data) => async dispatch => {
    try {
        dispatch(addResources({ resources: data }));
    } catch (e) {
        return console.error(e);
    }
}

export const clearResourcesAction = (data) => async dispatch => {
    dispatch(clearResources());
}

export const addLevelsAction = (data) => async dispatch => {
    try {
        dispatch(addLevels({ levels: data }));
    } catch (e) {
        return console.error(e);
    }
}

export const clearLevelsAction = () => async dispatch => {
    dispatch(clearLevels());
}
